// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:02:50

export default {
  "id": "escape-room-mystery-key",
  "slug": "escape-room-mystery-key",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/087e2873060f4ecdbb3ea47302aaf840-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/087e2873060f4ecdbb3ea47302aaf840/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Escape Room Mystery Key",
      "description": "Escape Room Mystery Key is an intense escape room adventure filled with horror and puzzle elements. Choose a role to enter an abandoned school or a hospital. Uncover hidden clues and keys to find your way out. In this game, you must carefully examine every detail in the room, searching for hidden clues.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Adventure",
        "Puzzle"
      ],
      "tags": [
        "escape",
        "highschool",
        "horror",
        "hospital",
        "scary"
      ]
    },
    "zh-CN": {
      "title": "密室逃脱神秘钥匙",
      "description": "《逃出密室之谜钥》是一款充满惊悚和解谜元素的紧张逃脱冒险游戏。选择一个角色进入废弃的学校或医院。揭露隐藏的线索和钥匙，找到你的出路。在这款游戏中，你必须仔细检查房间中的每一个细节，寻找隐藏的线索。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "冒险",
        "解谜"
      ],
      "tags": [
        "逃脱",
        "高中",
        "恐怖",
        "医院",
        "惊悚"
      ]
    },
    "zh-TW": {
      "title": "逃脫房謎之鑰",
      "description": "逃脫密室謎題關鍵是一款充滿驚悚和謎題元素的強烈逃脫密室冒險遊戲。選擇一個角色進入荒廢學校或醫院。發現隱藏的線索和關鍵，尋找逃離的方法。在這款遊戲中，你必须仔細檢查房間中的每個細節，尋找隱藏的線索。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "逃亡",
        "高中",
        "恐怖",
        "醫院",
        "驚悚"
      ]
    },
    "zh-HK": {
      "title": "逃脫房謎謎之鑰",
      "description": "逃離密室謎題鍵是一款充滿驚悚和解謎元素的緊張逃離室冒險遊戲。選擇一個角色進入廢棄的學校或醫院。發現隱藏的線索和鑰匙，尋找逃離的方法。在這款遊戲中，你必须仔細檢查房間的每一個細節，尋找隱藏的線索。",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "冒險",
        "謎題"
      ],
      "tags": [
        "逃離",
        "高中",
        "驚悚",
        "醫院",
        "驚嚇"
      ]
    },
    "ja": {
      "title": "脱出ルームミステリーの鍵",
      "description": "エスケイプルームミステリー・キーは、恐怖とパズル要素が満載の激しいエスケイプルームアドベンチャーです。廃墟の学校や病院に進入する役割を選びます。隠されたヒントや鍵を見つけ、脱出する方法を見つけ出しましょう。このゲームでは、部屋の中のあらゆる詳細を慎重に調べ、隠されたヒントを探す必要があります。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "アドベンチャー",
        "パズル"
      ],
      "tags": [
        "脱出",
        "高校",
        "ホラー",
        "病院",
        "怖い"
      ]
    },
    "ko": {
      "title": "탈출실 미스터리 키",
      "description": "escape room mystery key은 공포와 퍼즐 요소가 가득한 집중적인 탈출실 모험입니다. 버려진 학교나 병원에 진입할 역할을 선택하세요. 숨겨진 단서와 열쇠를 발견하여 탈출하는 방법을 찾으세요. 이 게임에서는 방 안의 모든 세부 사항을 주의 깊게 살피며 숨겨진 단서를 찾아야 합니다.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "모험",
        "퍼즐"
      ],
      "tags": [
        "탈출",
        "고등학교",
        "공포",
        "병원",
        "무서운"
      ]
    },
    "fr": {
      "title": "Clé Mystère de la Salle d'Évasion",
      "description": "Escape Room Mystery Key est une aventure d'évasion intenses imprégnée d'éléments de horror et de puzzles. Choisissez un rôle pour entrer dans une école abandonnée ou un hôpital. Découvrez des indices cachés et des clés pour trouver votre chemin de sortie. Dans ce jeu, vous devez examiner attentivement chaque détail de la pièce, cherchant des indices cachés.",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Aventure",
        "Puzzle"
      ],
      "tags": [
        "échapper",
        "lycée",
        "horreur",
        "hôpital",
        "effrayant"
      ]
    }
  }
};
